import type { AppProps } from 'next/app'

import '../../styles/globals.css'
import dynamic from 'next/dynamic'
import { ShopifyConsentTrackingScript } from '../vlp/components/shared/ShopifyConsentTrackingScript'

const DatadogInit = dynamic(
    () => import('../vlp/components/shared/DatadogInit'),
)

function MyApp({ Component, pageProps }: AppProps) {
    return (
        <>
            <DatadogInit />
            <ShopifyConsentTrackingScript />
            <Component {...pageProps} />
            <div id="modal-root"></div>
        </>
    )
}

export default MyApp
